export const CUSTOMER_TYPE          = 'customerType';
export const SALES_CHANNEL_NAME     = 'salesChannelName';
export const QUERY                  = 'query';
export const SEARCH_TYPE            = 'searchType';
export const COLLECTIONS            = 'collections';
export const EMAIL_RETRIEVE_TOKEN   = 'emailRetrieveToken';
export const RESET_PASSWORD_RETRIEVE_TOKEN   = 'resetPasswordRetrieveToken';



// WEBPACK FOOTER //
// ./src/const/query_params.js